export default "__VITE_ASSET__CXikQMzm__"